const KnowledgeBaseAdherenceCorrectness = {
  Correct: "correct",
  Incorrect: "incorrect",
  Unknown: "unknown"
};
function countIncorrectStatements(kbAdherence) {
  if (!kbAdherence || !kbAdherence.statements) {
    return 0;
  }
  return kbAdherence.statements.filter(
    (stmt) => stmt.correctness === KnowledgeBaseAdherenceCorrectness.Incorrect
  ).length;
}
function checkHasIncorrectStatement(kbAdherence) {
  return countIncorrectStatements(kbAdherence) > 0;
}
export {
  KnowledgeBaseAdherenceCorrectness,
  checkHasIncorrectStatement,
  countIncorrectStatements
};
//# sourceMappingURL=knowledgeBaseAdherence.js.map
